import React, { useState } from 'react';
import { Chessboard } from 'react-chessboard';
import { Chess } from 'chess.js';
import AchievementSystem from '../../components/AchievementSystem/AchievementSystem-v1.0.0.jsx';

const PlaygroundPage = () => {
  const [game, setGame] = useState(new Chess());
  const [gameHistory, setGameHistory] = useState([]);
  const [moveFrom, setMoveFrom] = useState('');
  const [optionSquares, setOptionSquares] = useState({});
  const [boardKey, setBoardKey] = useState(0);
  const [totalMoves, setTotalMoves] = useState(0);

  // تابع برای حرکت مهره‌ها
  function onPieceDrop(sourceSquare, targetSquare) {
    try {
      const gameCopy = new Chess(game.fen());
      const move = gameCopy.move({
        from: sourceSquare,
        to: targetSquare,
        promotion: 'q', // پیش‌فرض ارتقا به وزیر
      });

      if (move) {
        setGame(gameCopy);
        setGameHistory([...gameHistory, {
          move: move.san,
          piece: move.piece,
          from: sourceSquare,
          to: targetSquare,
          number: gameHistory.length + 1
        }]);
        setTotalMoves(prev => prev + 1);
        setMoveFrom('');
        setOptionSquares({});
        return true;
      }
      return false;
    } catch (error) {
      console.log('حرکت نامعتبر:', error);
      return false;
    }
  }

  // وقتی روی مهره کلیک می‌شه
  function onSquareClick(square) {
    setMoveFrom(square);
    
    const gameCopy = new Chess(game.fen());
    const moves = gameCopy.moves({
      square: square,
      verbose: true
    });

    if (moves.length > 0) {
      const newSquares = {};
      moves.map((move) => {
        newSquares[move.to] = {
          background: 'rgba(255, 255, 0, 0.4)',
          borderRadius: '50%'
        };
        return move;
      });
      newSquares[square] = {
        background: 'rgba(255, 255, 0, 0.4)'
      };
      setOptionSquares(newSquares);
    } else {
      setOptionSquares({});
      setMoveFrom('');
    }
  }

  // حرکت ربات (کاملاً تست شده)
  const makeBotMove = () => {
    console.log('دکمه ربات فشرده شد');
    
    // چک کن که نوبت ربات باشه (سیاه)
    if (game.turn() !== 'b') {
      console.log('نوبت ربات نیست. نوبت:', game.turn());
      return;
    }

    // چک کن بازی تمام نشده باشه
    if (game.isGameOver()) {
      console.log('بازی تمام شده');
      return;
    }

    try {
      const gameCopy = new Chess(game.fen());
      const moves = gameCopy.moves();
      
      console.log('تعداد حرکات ممکن:', moves.length);
      
      if (moves.length > 0) {
        const randomIndex = Math.floor(Math.random() * moves.length);
        const selectedMove = moves[randomIndex];
        console.log('حرکت انتخاب شده:', selectedMove);
        
        const moveResult = gameCopy.move(selectedMove);
        
        if (moveResult) {
          setGame(gameCopy);
          setGameHistory(prev => [...prev, {
            move: moveResult.san,
            piece: moveResult.piece,
            from: moveResult.from,
            to: moveResult.to,
            number: prev.length + 1
          }]);
          setTotalMoves(prev => prev + 1);
          setMoveFrom('');
          setOptionSquares({});
          
          console.log('ربات با موفقیت حرکت کرد:', moveResult.san);
        } else {
          console.log('ربات نتوانست حرکت کند');
        }
      } else {
        console.log('هیچ حرکت ممکنی وجود ندارد');
      }
    } catch (error) {
      console.error('خطا در حرکت ربات:', error);
    }
  };

  // ریست بازی
  const resetGame = () => {
    setGame(new Chess());
    setGameHistory([]);
    setMoveFrom('');
    setOptionSquares({});
    setBoardKey(prev => prev + 1);
    setTotalMoves(0);
    console.log('بازی ریست شد');
  };

  // حرکت به عقب
  const undoMove = () => {
    if (gameHistory.length > 0) {
      const gameCopy = new Chess(game.fen());
      gameCopy.undo();
      setGame(gameCopy);
      setGameHistory(gameHistory.slice(0, -1));
      setTotalMoves(prev => prev - 1);
      setMoveFrom('');
      setOptionSquares({});
    }
  };

  const getGameStatus = () => {
    if (game.isCheckmate()) return 'کیش و مات! 🎯';
    if (game.isDraw()) return 'مساوی! 🤝';
    if (game.isStalemate()) return 'پات! 🛑';
    if (game.isCheck()) return 'کیش! ⚡';
    return 'بازی در جریان';
  };

  // استایل‌های داخلی
  const styles = {
    playgroundPage: {
      padding: '20px',
      maxWidth: '1400px',
      margin: '0 auto',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
    },
    playgroundHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px',
      padding: '25px',
      background: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
      backdropFilter: 'blur(10px)'
    },
    playgroundHeaderH1: {
      color: '#2c3e50',
      margin: '0',
      fontSize: '32px',
      fontWeight: '700'
    },
    headerButtons: {
      display: 'flex',
      gap: '15px'
    },
    resetBtn: {
      padding: '14px 28px',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      fontSize: '15px',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
      color: 'white'
    },
    botBtn: {
      padding: '14px 28px',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      fontSize: '15px',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      background: 'linear-gradient(135deg, #3498db, #2980b9)',
      color: 'white'
    },
    undoBtn: {
      padding: '14px 28px',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      fontSize: '15px',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      background: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
      color: 'white'
    },
    playgroundContent: {
      display: 'grid',
      gridTemplateColumns: '1fr 400px',
      gap: '30px',
      alignItems: 'start'
    },
    chessboardSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    chessboardWrapper: {
      display: 'flex',
      justifyContent: 'center',
      background: 'rgba(255, 255, 255, 0.95)',
      padding: '15px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
      backdropFilter: 'blur(10px)',
      transform: 'scale(0.85)',
      transformOrigin: 'center',
      margin: '-10px'
    },
    gameControls: {
      display: 'flex',
      justifyContent: 'center'
    },
    turnIndicator: {
      background: 'rgba(255, 255, 255, 0.95)',
      padding: '15px 30px',
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    },
    turnBadge: {
      fontSize: '18px',
      fontWeight: '600',
      padding: '10px 20px',
      borderRadius: '8px',
      transition: 'all 0.3s ease'
    },
    whiteTurn: {
      background: 'linear-gradient(135deg, #ecf0f1, #bdc3c7)',
      color: '#2c3e50'
    },
    blackTurn: {
      background: 'linear-gradient(135deg, #2c3e50, #34495e)',
      color: 'white'
    },
    gameInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '25px'
    },
    statusCard: {
      background: 'rgba(255, 255, 255, 0.95)',
      padding: '25px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    },
    historyCard: {
      background: 'rgba(255, 255, 255, 0.95)',
      padding: '25px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    },
    instructionsCard: {
      background: 'rgba(255, 255, 255, 0.95)',
      padding: '25px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    },
    achievementsSection: {
      marginBottom: '0'
    },
    cardH3: {
      marginTop: '0',
      color: '#2c3e50',
      borderBottom: '3px solid #3498db',
      paddingBottom: '15px',
      fontSize: '20px',
      fontWeight: '600'
    },
    statusContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },
    statusText: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#e74c3c',
      textAlign: 'center',
      padding: '12px',
      background: 'rgba(231, 76, 60, 0.1)',
      borderRadius: '8px',
      border: '2px solid #e74c3c'
    },
    movesList: {
      maxHeight: '350px',
      overflowY: 'auto',
      padding: '15px',
      background: 'rgba(248, 249, 250, 0.8)',
      borderRadius: '12px',
      border: '1px solid rgba(0,0,0,0.1)'
    },
    moveItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px',
      marginBottom: '8px',
      background: 'white',
      borderRadius: '10px',
      borderLeft: '5px solid #3498db',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      transition: 'transform 0.2s ease'
    },
    moveNumber: {
      fontWeight: 'bold',
      color: '#7f8c8d',
      marginLeft: '12px',
      minWidth: '30px',
      fontSize: '14px'
    },
    moveText: {
      color: '#2c3e50',
      fontSize: '14px',
      fontWeight: '500'
    },
    noMoves: {
      textAlign: 'center',
      color: '#7f8c8d',
      fontStyle: 'italic',
      padding: '30px',
      fontSize: '16px'
    },
    instructionsContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    instructionItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      padding: '12px',
      background: 'rgba(52, 152, 219, 0.1)',
      borderRadius: '10px',
      border: '1px solid rgba(52, 152, 219, 0.2)'
    },
    icon: {
      fontSize: '20px',
      minWidth: '30px'
    }
  };

  return (
    <div style={styles.playgroundPage}>
      <div style={styles.playgroundHeader}>
        <h1 style={styles.playgroundHeaderH1}>♟️ زمین بازی شطرنج</h1>
        <div style={styles.headerButtons}>
          <button 
            style={styles.resetBtn} 
            onClick={resetGame}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-3px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            🔄 بازی جدید
          </button>
          <button 
            style={styles.botBtn} 
            onClick={makeBotMove}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-3px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            🤖 حرکت ربات
          </button>
          <button 
            style={styles.undoBtn} 
            onClick={undoMove}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-3px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            ↩️ حرکت قبلی
          </button>
        </div>
      </div>

      <div style={styles.playgroundContent}>
        <div style={styles.chessboardSection}>
          <div style={styles.chessboardWrapper}>
            <Chessboard
              key={boardKey}
              id="playgroundBoard"
              position={game.fen()}
              onPieceDrop={onPieceDrop}
              onSquareClick={onSquareClick}
              boardWidth={380}
              customBoardStyle={{
                borderRadius: '8px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
              }}
              customDarkSquareStyle={{ backgroundColor: '#b58863' }}
              customLightSquareStyle={{ backgroundColor: '#f0d9b5' }}
              customSquareStyles={{
                ...optionSquares,
                ...(moveFrom
                  ? {
                      [moveFrom]: {
                        backgroundColor: 'rgba(255, 255, 0, 0.6)',
                      },
                    }
                  : {}),
              }}
              arePiecesDraggable={true}
              snapToCursor={true}
            />
          </div>
          
          <div style={styles.gameControls}>
            <div style={styles.turnIndicator}>
              <div style={{
                ...styles.turnBadge,
                ...(game.turn() === 'w' ? styles.whiteTurn : styles.blackTurn)
              }}>
                نوبت: {game.turn() === 'w' ? '⚪ سفید' : '⚫ سیاه'}
              </div>
            </div>
          </div>
        </div>

        <div style={styles.gameInfo}>
          <div style={styles.statusCard}>
            <h3 style={styles.cardH3}>📊 وضعیت بازی</h3>
            <div style={styles.statusContent}>
              <p style={styles.statusText}>{getGameStatus()}</p>
              <p>تعداد حرکات: <strong>{gameHistory.length}</strong></p>
              <p>وضعیت: <strong>{game.isGameOver() ? 'پایان یافته' : 'در حال بازی'}</strong></p>
            </div>
          </div>

          <div style={styles.historyCard}>
            <h3 style={styles.cardH3}>📝 تاریخچه حرکات</h3>
            <div style={styles.movesList}>
              {gameHistory.length === 0 ? (
                <p style={styles.noMoves}>هنوز حرکتی انجام نشده</p>
              ) : (
                gameHistory.map((moveObj, index) => (
                  <div key={index} style={{
                    ...styles.moveItem,
                    ...(index % 2 === 0 ? 
                      { borderLeftColor: '#ecf0f1', background: 'linear-gradient(135deg, #ffffff, #f8f9fa)' } : 
                      { borderLeftColor: '#2c3e50', background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)' }
                    )
                  }}>
                    <span style={styles.moveNumber}>{Math.ceil((index + 1) / 2)}.</span>
                    <span style={styles.moveText}>
                      <strong>{moveObj.move}</strong>
                      {moveObj.from && ` (${moveObj.from}→${moveObj.to})`}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>

          <div style={styles.instructionsCard}>
            <h3 style={styles.cardH3}>🎮 راهنمای بازی</h3>
            <div style={styles.instructionsContent}>
              <div style={styles.instructionItem}>
                <span style={styles.icon}>🖱️</span>
                <span>مهره رو بکش و رها کن</span>
              </div>
              <div style={styles.instructionItem}>
                <span style={styles.icon}>🤖</span>
                <span>برای بازی با ربات دکمه رو بزن</span>
              </div>
              <div style={styles.instructionItem}>
                <span style={styles.icon}>↩️</span>
                <span>برای بازگشت به حرکت قبلی</span>
              </div>
              <div style={styles.instructionItem}>
                <span style={styles.icon}>🔄</span>
                <span>برای شروع مجدد بازی جدید</span>
              </div>
            </div>
          </div>

          {/* سیستم امتیاز و نشان‌ها */}
          <div style={styles.achievementsSection}>
            <AchievementSystem 
              gameHistory={gameHistory}
              movesCount={totalMoves}
              gameStatus={getGameStatus()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaygroundPage;